export default class DonorRelative {
  // @ts-ignore
  public id: string;
  // @ts-ignore
  public laboratoryId: string;
  public lastName: string;
  public firstName: string;
  public middleName: string;
  public externalId: string;
  public weight: number | null;
  public birthday: Date;
  public bloodType: number | null;
  public rh: string;
  // @ts-ignore
  public grid: string;
  public tcOrganizationId: string;
  public tcCode: string;
  public patientId: string;
  public patientName: string;
  public status: number | null;
  public comment: string;
  public operatorId: string;
  public operatorEmail: string;
  public operatorPhone: string;
  public operatorAdphone: string;
  public operatorName: string;
  public hlaDate: Date | null;
  public ctOrderDate: Date | null;
  public ctSendDate: string | null;
  public idmSendDate: Date | null;
  public ctReceiveDate: string | null;

  // @ts-ignore
  public diagnosis: string;
  // @ts-ignore
  public statuses: [];
  // @ts-ignore
  public operators: [];
  // @ts-ignore
  public operatorsData: [];
  // @ts-ignore
  public isReserved: boolean;

  // @ts-ignore
  public services: [];
  // @ts-ignore
  public donorServices: [];
  // @ts-ignore
  public donorBills: [];
  // @ts-ignore
  public service: string;

  public isTransplantationAccept: string;
  // @ts-ignore
  public collectionCenterId: string;
  // @ts-ignore
  public collectionCenterName: string;
  // @ts-ignore
  public transfusiologistId: string;
  // @ts-ignore
  public transfusiologistName: string;
  // @ts-ignore
  public transfusiologistEmail: string;
  // @ts-ignore
  public transfusiologistPhone: string;
  // @ts-ignore
  public transfusiologistAdphone: string;
  // @ts-ignore
  public medicalExamination: Date;
  // @ts-ignore
  public idmConfirm: string;
  // @ts-ignore
  public collectionDate: Date | null;
  // @ts-ignore
  public collectionMethodId: string | null;
  // @ts-ignore
  public collectionMethods: [];
  public ctFileInfo: any;
  public getCellsFactDate: Date;
  public getCellsFactMethod: string;
  public cellularity: string;
  public isFrozen: boolean;
  // @ts-ignore
  public transfusiologists: [];
  // @ts-ignore
  public genders: [];
  // @ts-ignore
  public bloodTypes: [];
  // @ts-ignore
  public rhs: [];
  // @ts-ignore
  public hlas: [];
  // @ts-ignore
  public infectionsResult: any;

  constructor() {
    this.patientId = '';
    this.externalId = '';
    this.lastName = '';
    this.firstName = '';
    this.middleName = '';
    this.patientName = '';
    this.tcCode = '';
    this.tcOrganizationId = '';
    this.status = null;
    this.comment = '';
    this.weight = null;
    this.birthday = new Date();
    this.bloodType = null;
    this.rh = '';
    this.operatorId = '';
    this.operatorEmail = '';
    this.operatorPhone = '';
    this.operatorAdphone = '';
    this.operatorName = '';
    this.hlaDate = new Date();
    this.ctOrderDate = new Date();
    this.ctSendDate = '';
    this.idmSendDate = new Date();
    this.ctReceiveDate = '';
    this.ctFileInfo = null;
    this.isTransplantationAccept = 'false';
    this.getCellsFactDate = new Date();
    this.getCellsFactMethod = '';
    this.cellularity = '';
    this.isFrozen = false;
  }
}
